var React = require('react');

function ArtPickedIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"29","width":"64","height":"40","fill":"#F6F5F3","key":0}),React.createElement("path",{"d":"M86 1H111M86 1V23H111V1M86 1V5H111V1M52 53.5L65.5 39L75.5 47.5L84 42.5L97 53.5M83\r\n              9H48V79H101V26M83 13H52V75H97V26M89 8H97V12H89V8ZM89 15H97V19H89V15ZM100 8H108V12H100V8ZM100\r\n              15H108V19H100V15ZM65 25C65 27.2091 63.2091 29 61 29C58.7909 29 57 27.2091 57 25C57 22.7909 58.7909\r\n              21 61 21C63.2091 21 65 22.7909 65 25Z","stroke":"#FCB34E","strokeWidth":"1.5","key":1})]);
}

ArtPickedIcon.defaultProps = {"width":"112","height":"80","viewBox":"0 0 112 80","fill":"none"};

module.exports = ArtPickedIcon;

ArtPickedIcon.default = ArtPickedIcon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/art-picked-icon.svg
// module id = 1049
// module chunks = 0